import moment from 'moment-timezone';
import { getDaysOfWeek } from './getDaysOfWeek';

/**
 * Gets the days of the week
 *
 * @param dayInWeek - Any day in the week you want to start at
 * @returns - An array with each day of the week for the current locale
 */
export function getDaysOfWeekFor(dayInWeek: Date): moment.Moment[] {
    return getDaysOfWeek().map(dayNumber => moment(dayInWeek).weekday(dayNumber));
}
